/**
 * One place errors are reported from. Console today; plug Sentry/PostHog here
 * (deepdive-v2's boundary had a TODO and a console.error).
 */
export function reportError(error: unknown, context: Record<string, unknown> = {}) {
  console.error('[deepdive]', context, error);
}
